const footerDict = {
  CONTACT_ME: "Contattami",
  CONTACT_MESSAGE: "Contattami per iniziare una collaborazione insieme",
  MILAN: "Milano",
  ITALY: "Italia",
  BYE: "A presto!",
};
export default footerDict;
